//set to true when testing
var beta = zipLoc = false;
//var beta = true;
//var zipLoc = false;

var e = thecode = "";
var conversion_rate;
var current_country;

$( document ).ready(function() {

  var cookieRate = getCookie("conversion_rate");
  if (cookieRate) {
    conversion_rate = parseFloat(cookieRate);
    console.log("Cookie found. conversion_rate = ", conversion_rate);
  } else {
    getCADconversionRate().then(conversion_rate => {
	  console.log(`Conversion rate for ${Shopify.currency.active}:`, conversion_rate);
	  console.log('Settting conversion_rate cookie.');
	  document.cookie = "conversion_rate=" + conversion_rate + "; path=/";
	});
  }

  current_country = Shopify.country;
  if(!current_country)
    current_country = "US";

  $("#thecode").attr("autocomplete","off");
  $("#thecode").keyup(function (e) {
    if (e.keyCode == 13) {
      getRates(e);
    }
  });

});

function getRates(e) {

  //console.log(conversion_rate);
  thecode = $("#thecode").val().trim();
  thecode = thecode.replace(/[^A-Za-z0-9\s\-]/g, '');
  $("#thecode").val(thecode);
  //console.log("cc=" + current_country);
  
  //zipLoc = validZip(thecode);
  zipLoc = validateZipCode(thecode);
  if(zipLoc == false) {

    //alert('Invalid US Zip / Canadian Postal Code');
    alert('Unable to validate provided Zip / Postal Code');
    return false;

  } else {
    
    if(current_country !== "US" && current_country !== "CA")
      zipLoc = "Other"; //override 'zipLoc' so we don't incorrectly identify as US or CA when zip/postal code is detected as US/CA, but not actually

    if(!conversion_rate) {
      alert('Error calling shipping rate calculator, please refresh your page and try again.');
      return false;
    }

    //ship_qty = $(".form-input--incrementTotal").val();
    var pQty = getShipQuantity();

    if(typeof pQty == "undefined") {
      //alert('Invalid shipping quantity');
      //return false;
      pQty = 1;
    }

    var dimensions = getDimensions(box_dimensions);
    if (!dimensions) {
      dimensions.length = dimensions.width = dimensions.height = 12;
      //console.log("Length:", dimensions.length);
      //console.log("Width:", dimensions.width);
      //console.log("Height:", dimensions.height);
    }
    
    var pWeight = getShipWeight();

    //if(typeof pWeight != 'undefined' && typeof pWidth != 'undefined' && typeof pHeight != 'undefined' && typeof pDepth != 'undefined') {
    if(typeof pWeight != 'undefined') {

      $( "#ship-content" ).html($("#ship-spinner").html());

      $('#ship-container')
      .modal({
        useFlex:false,
        onHidden: function() {
          ship_reset();
        }
      })
      .modal('setting', 'closable', false)
      .modal('show');

      url = "https://linestogo.logika.net/ups/lookup.php";
      if(beta)
        url = "http://linestogo.beta.logika.net/ups/lookup.php";

      var req = $.ajax({

        //url: url + "?code=" + thecode + "&weight=" + pWeight + "&width=" + pWidth + "&height=" + pHeight + "&depth=" + pDepth + "&qty=" + ship_qty,
        //url: url + "?code=" + thecode + "&weight=" + pWeight + "&qty=" + pQty + "&country=" + zipLoc,
                                                                                  //CA, US, Other
        url: url + "?code=" + thecode + "&weight=" + pWeight + "&qty=" + pQty + "&l=" + dimensions.length + "&w=" + dimensions.width + "&h=" + dimensions.height + "&country=" + zipLoc + "&c_code=" + current_country,
        dataType: "jsonp",
        jsonp : "callback",
        jsonpCallback: "ajax_complete", // callback function
        timeout: 10000

      });

      req.fail(function() { //called by ajax function if connection error, etc.

        ship_reset();
        console.log('oops.')
        alert('There appears to be a problem with your connection.');

      });

    } else {

      alert('Unable to process request. Insufficient product data to obtain quote. Try refreshing your page.');

    }

  }

}

function ajax_complete(data) {

  if(typeof data !== "undefined" && typeof data == "object") {

    //console.log(typeof data[0]);
    if(typeof data[0] !== "undefined" && typeof data[0] == "string" && data[0].indexOf("error") >=0 ) {
      $("#ship-content").html(data[1]);
      $("#ship-header").text("Error");
      $('#ship-container')
        .modal('setting', 'closable', true);
      return false;
    }

    var output = outputAlt = "";
    output = "<table border=0 cellpadding=10 style='xfont-size:12px;'><tr><td><b>Shipping Method</b></td><td><b>Amount</b></td><td><b>Shipping Time</b></td></tr>";
    i = 0;

    var isFixed = true;
    if(zipLoc == "US") {

      var stateException = ["AK", "HI", "PR"];
      var state = getState(thecode.substr(0,5)); //just in case we have a dash code
      if(state == false || stateException.includes(state.code) )
        isFixed = false;

    } else if(zipLoc == "CA") { //Canada

      var provinceException = ['Y0A','YOB','Y1A','X0A','XOB','X0C','XOE','X0G','X1A'];
      var provincePrefix = thecode.substr(0,3).toUpperCase();
      if( provinceException.includes(provincePrefix) )
        isFixed = false;

    } else { //Must be International

      isFixed = false;

    }

    var one_day = two_day = false;
    var isInternational = false;

    $.each(data, function(n,v) {

      var isAlt = false;

      //if(v.ServiceType == "INTERNATIONAL_PRIORITY" || v.ServiceType == "INTERNATIONAL_ECONOMY") {
      //if(v.ServiceType !== "International First") {
      //Not need, as we are parsing out options not wanted to display on server side, before returning data

      if(zipLoc == "Other") { //this is a non US/CA address

        if(v.ServiceType == "UPS Saver") { //this is only one we want to show for overseas shipping (non US/CA)

          v.ServiceType = "UPS 3 Day";
          v.TimeStamp = "3 Business Days";
          console.log(v.Amount);
          console.log(conversion_rate);
          v.Amount = formatShippingAmount(parseFloat(v.Amount) * conversion_rate);
          output += "<tr><td>" + v.ServiceType + "</td><td>" + v.Amount + "</td><td>" + v.TimeStamp + "</td></tr>";

          isInternational = true;
          return true;

        }


      } else {

        if(v.ServiceType == "UPS Standard") { //All regions CA/US

          if(isFixed) {
            v.Amount = "Free Shipping";
          } else {
            //v.Amount = "$" + v.Amount;
            v.Amount = formatShippingAmount(parseFloat(v.Amount) * conversion_rate);
	      }

          v.ServiceType = "UPS Ground";
                                   //Canada                               //Other / US
        } else if(v.ServiceType == "UPS 2nd Day Air" || v.ServiceType == "UPS Worldwide Express" || v.ServiceType == "UPS 3 Day Select") { //temporarily offering $14.99, instead of quoted price, for international economy

          //v.Amount = "$" + v.Amount;
          //v.Amount = "$14.99"; //temporarily fixed priority of $14.99

          //this is just to make sure we don't display mulitple types of 2-day options, since regardless, currently, they are all free since isFixed = true
          if(two_day)
            return true;
          two_day = true;

          if(isFixed)
            v.Amount = "Free Shipping";
          else
            //v.Amount = "$" + v.Amount;
            v.Amount = formatShippingAmount(parseFloat(v.Amount) * conversion_rate);

          v.ServiceType = "UPS 2 Day";
          v.TimeStamp = "2 Business Days";

        } else {
  	  	                     //Canada             //Other / US
  	      if(v.ServiceType == "UPS Next Day Air" || v.ServiceType == "UPS Next Day Air Early A.M." || v.ServiceType == "UPS Worldwide Expedited") {

            if(one_day)
              return true;
            one_day = true;

            //v.Amount = "$" + v.Amount; //temporarily fixed priority of $25.99
            if(isFixed)
              v.Amount = "Free Shipping";
            else
              v.Amount = formatShippingAmount(parseFloat(v.Amount) * conversion_rate);
              //v.Amount = "$" + v.Amount;

            v.ServiceType = "UPS Next Day";
            v.TimeStamp = "1 Business Day";

  	      } else {

            //return; //equivalent to continue in regular JS
  	        //Let's capture "other" types in case we end up finding nothing, we'll display these instead (i=0)
  	        if(v.ServiceType !== "undefined") {
              v.Amount = formatShippingAmount(parseFloat(v.Amount) * conversion_rate);
              outputAlt += "<tr><td>" + v.ServiceType + "</td><td>" + v.Amount + "</td><td>" + v.TimeStamp + "</td></tr>";
              isAlt = true;
            }
  	      }
        }
      }

      if(zipLoc !== "Other") {
        if(!isAlt) {
          output += "<tr><td>" + v.ServiceType + "</td><td>" + v.Amount + "</td><td>" + v.TimeStamp + "</td></tr>";
          i++;
	    }
	  }

    });

    if(!isInternational) {
      if(i < 3) { //didn't get teh standard 3 options, must be altnerative location, let's add those as well

  	    if(outputAlt.length) {
  	      output += outputAlt;
  	    } else {
          output = "<table border=0 cellpadding=5><tr><td>Sorry, an error occured, please try again, or check your zip/postal code.</td></tr></table>";
        }
	  }
    }

    $("#ship-content").html(output);
    // $( "#ship-container" ).html($("#ship-complete").html());
    $("#ship-header").text("Shipping Estimates");
    $('#ship-container')
    .modal('setting', 'closable', true);

  } else {

    ship_reset();
    alert('Unable to communication with shipping provider');

  }

}

function validZip_OLD(zip) {

  if( zip.match(/^[0-9]{5}$/) || zip.match(/^[0-9\-]{10}$/) ) { //American
    //return true;
    return "US";
  }

  /*
  if (zip.match(/^[0-9\-]{10}$/)) { //American with dash code
    //return true;
    return "US";
  }
  */

  //zip=zip.toUpperCase();
  if (zip.match(/^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i)) { //Canadian
    //return true;
    return "CA";
  }

  return false;
}

function validateZipCode(zip) {
  // Remove any extra whitespace from the input.
  zip = zip.trim();

  // Regular expression for US ZIP codes:
  // Matches 5 digits optionally followed by a hyphen and 4 additional digits.
  const usRegex = /^\d{5}(-\d{4})?$/;

  // Regular expression for Canadian postal codes:
  // Matches a pattern like A1A 1A1 or A1A1A1.
  const caRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

  // A general check for postal codes from other countries.
  // Here, we consider the code "valid" if it:
  //   - Contains only alphanumeric characters, spaces, or hyphens.
  //   - Has at least 3 characters.
  //   - Does not start or end with a space or hyphen.
  const generalPostalRegex = /^[A-Za-z0-9](?:[A-Za-z0-9 -]*[A-Za-z0-9])?$/;

  // Optional: Enforce a minimum length (2 characters) for any postal code.
  if (zip.length < 2) {
    return false;
  }

  if (usRegex.test(zip)) {
    return "US";
  } else if (caRegex.test(zip)) {
    return "CA";
  } else if (generalPostalRegex.test(zip)) {
    return "Other";
  } else {
    return false;
  }
}

function flipShip() {

  $("#shipping_txt").hide();
  $("#code").show();

}

function ship_reset() {

  $("#ship-container").modal( "hide" );
  $("#ship-msgContent").html("");
  $("#ship-content").html("");
  $("#ship-header").text("Retrieving Estimates...");
  //$("#shipping_txt").show();
  //$("#code").hide();

}

function getState(zipcode) {

    // Returns false on invalid zip-- else returns {code:"XX" long:"XXXXXXXXX"}

    // Ensure param is a string to prevent unpredictable parsing results
    if (typeof zipcode !== 'string') {
        console.log('Must pass the zipcode as a string. -- Otherwise leading zeros could cause your zip code to be parsed outside base 10.');
        return;
    }

    // Ensure you don't parse codes that start with 0 as octal values
    zipcode = parseInt(zipcode,10);

    // Code blocks alphabetized by state
    var states = [{min: 35000, max:36999, code: 'AL', long: "Alabama"},
    {min: 99500, max:99999, code: 'AK', long: "Alaska"},
    {min: 85000, max:86999, code: 'AZ', long: "Arizona"},
    {min: 71600, max:72999, code: 'AR', long: "Arkansas"},
    {min: 90000, max:96699, code: 'CA', long: "California"},
    {min: 80000, max:81999, code: 'CO', long: "Colorado"},
    {min: 6000,  max:6999,  code: 'CT', long: "Connecticut"},
    {min: 19700, max:19999, code: 'DE', long: "Deleware"},
    {min: 32000, max:34999, code: 'FL', long: "Florida"},
    {min: 30000, max:31999, code: 'GA', long: "Georgia"},
    {min: 96700, max:96999, code: 'HI', long: "Hawaii"},
    {min: 83200, max:83999, code: 'ID', long: "Idaho"},
    {min: 60000, max:62999, code: 'IL', long: "Illinois"},
    {min: 46000, max:47999, code: 'IN', long: "Indiana"},
    {min: 50000, max:52999, code: 'IA', long: "Iowa"},
    {min: 66000, max:67999, code: 'KS', long: "Kansas"},
    {min: 40000, max:42999, code: 'KY', long: "Kentucky"},
    {min: 70000, max:71599, code: 'LA', long: "Louisiana"},
    {min: 3900,  max:4999,  code: 'ME', long: "Maine"},
    {min: 20600, max:21999, code: 'MD', long: "Maryland"},
    {min: 1000,  max:2799,  code: 'MA', long: "Massachusetts"},
    {min: 48000, max:49999, code: 'MI', long: "Michigan"},
    {min: 55000, max:56999, code: 'MN', long: "Minnesota"},
    {min: 38600, max:39999, code: 'MS', long: "Mississippi"},
    {min: 63000, max:65999, code: 'MO', long: "Missouri"},
    {min: 59000, max:59999, code: 'MT', long: "Montana"},
    {min: 27000, max:28999, code: 'NC', long: "North Carolina"},
    {min: 58000, max:58999, code: 'ND', long: "North Dakota"},
    {min: 68000, max:69999, code: 'NE', long: "Nebraska"},
    {min: 88900, max:89999, code: 'NV', long: "Nevada"},
    {min: 3000, max:3899, code: 'NH', long: "New Hampshire"},
    {min: 7000, max:8999, code: 'NJ', long: "New Jersey"},
    {min: 87000, max:88499, code: 'NM', long: "New Mexico"},
    {min: 10000, max:14999, code: 'NY', long: "New York"},
    {min: 43000, max:45999, code: 'OH', long: "Ohio"},
    {min: 73000, max:74999, code: 'OK', long: "Oklahoma"},
    {min: 97000, max:97999, code: 'OR', long: "Oregon"},
    {min: 15000, max:19699, code: 'PA', long: "Pennsylvania"},
    {min: 300, max:999, code: 'PR', long: "Puerto Rico"},
    {min: 2800, max:2999, code: 'RI', long: "Rhode Island"},
    {min: 29000, max:29999, code: 'SC', long: "South Carolina"},
    {min: 57000, max:57999, code: 'SD', long: "South Dakota"},
    {min: 37000, max:38599, code: 'TN', long: "Tennessee"},
    {min: 75000, max:79999, code: 'TX', long: "Texas"},
    {min: 88500, max:88599, code: 'TX', long: "Texas"},
    {min: 84000, max:84999, code: 'UT', long: "Utah"},
    {min: 5000, max:5999, code: 'VT', long: "Vermont"},
    {min: 22000, max:24699, code: 'VA', long: "Virgina"},
    {min: 20000, max:20599, code: 'DC', long: "Washington DC"},
    {min: 98000, max:99499, code: 'WA', long: "Washington"},
    {min: 24700, max:26999, code: 'WV', long: "West Virginia"},
    {min: 53000, max:54999, code: 'WI', long: "Wisconsin"},
    {min: 82000, max:83199, code: 'WY', long: "Wyoming"}];

    var state = states.filter(function(s){
      return s.min <= zipcode && s.max >= zipcode;
    });

    if (state.length == 0){
        return false;
    } else if (state.length > 1) {
        console.error("Whoops found two states");
    }
    return {code:state[0].code, long:state[0].long};

}

function getShipQuantity() {

  var qty = 1;
  //this is a hack to theme.js to force setting of an attribute named 'count' with quantity when increment/decrement, for some reason, the input value in source HTML does not update despite value displayed being correct in quantity input box.
  $(".js-qty__num").each(function() {
    var numId = $(this).attr("id");
    //console.log($(this));
    if(numId.indexOf("Quantity") >=0) {
      qty = $(this).attr("count");
      //console.log(qty);
    }
  })

  return qty;

}

function getShipWeight() {
  var weight = 1000;
  if($('[aria-label="Product JSON"]').length) {
    var pString = $.trim($('[aria-label="Product JSON"]').text());
    if(pString !== 'undefined' && pString.length) {
      var pJSON;
      try {
         pJSON = JSON.parse(pString);
      } catch (e) {
        pJSON = "5"; //just use arbitrary default
        console.log('error parsing weight from JSON'); // error in the above string (in this case, yes)!
      }
      //var pJSON = JSON.parse(pString);
      if(pJSON !== "undefined" && pJSON[0] !== "undefined" && pJSON[0].weight !== "undefined") {
        weight = parseFloat(pJSON[0].weight) || 1000;
      }
    }
  }
  //weight is in grams, convert to KG
  //weight = weight / 1000;
  //return weight+" KGS";
  //weight is in grams provided by shopify in tmeplate, convert to lbs
  weight = weight / 454;
  return Math.ceil(weight);
}

function getDimensions(dimString) {
    // Check if pDims is set and valid
    if (!dimString || !dimString.includes('x')) {
        console.error("Invalid dimensions string");
        return null;
    }

    // Remove quotes and extra spaces, then split by 'x'
    let dims = dimString.replace(/"/g, "").split("x").map(d => d.trim());

    // Ensure we have exactly 3 values
    if (dims.length !== 3) {
        console.error("Unexpected dimensions format");
        return null;
    }

    // Convert to numbers and return as an object
    return {
        length: parseFloat(dims[0]),
        width: parseFloat(dims[1]),
        height: parseFloat(dims[2])
    };
}

function validProvince(code) {

}

// Global variable examples:
//var ship_money_format = "${{amount}}";
// var ship_money_format = "{{amount_with_comma_separator}} kr";

//note, there is a duplicate of this function in pfResults.js as well that if changes are made need to be done in both locations
function formatShippingAmount(amount) {

  // Use a regular expression to find the placeholder in ship_money_format.
  // This regex finds the text between double curly braces.
  var placeholderMatch = ship_money_format.match(/{{\s*(.*?)\s*}}/);

  var placeholder = placeholderMatch[1]; // e.g., "amount" or "amount_with_comma_separator"
  var formattedAmount;

  // If no placeholder is found, default to us/ca (not that it matters, just set to something since we are checking for EU style below, and all else is us/ca style)
  if (!placeholderMatch) {
    placeholder = "amount";
  }

  // Format the amount based on the placeholder.
  if (placeholder === "amount_with_comma_separator") {
    // European style: Using the 'de-DE' locale converts 1234.56 to "1.234,56"
    formattedAmount = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } else {
    // North American style, e.g. "1,234.56"
    formattedAmount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);

  }
  // Replace the placeholder (including the braces) with the formatted number.
  var result = ship_money_format.replace(/{{\s*.*?\s*}}/, formattedAmount);
  return result;

}

/**
 * Converts the price in CAD to the currency defined in Shopify.currency.active.
 * If active currency is "CAD", returns the original price.
 *
 * @returns {Promise<number>} The price converted to the active currency.
 */
async function getCADconversionRate() {

  // Extract the active currency code from the Shopify.currency JSON.
  const activeCurrency = Shopify.currency.active;

  // If active currency is CAD, no conversion is needed.
  if (activeCurrency === "CAD") {
    return 1;
  }

  // Construct the API URL.
  const apiUrl = `https://api.frankfurter.dev/v1/latest?base=CAD&amount=1&to=${activeCurrency}`;

  try {
    // Make the API request.
    const response = await fetch(apiUrl);
    if (!response.ok) {
      return 1;
      console.log(`API request failed with status ${response.status}`);
      //throw new Error(`API request failed with status ${response.status}`);
    }

    // Parse the JSON response.
    const data = await response.json();

    // Check that the expected "rates" property exists and contains the active currency.
    if (data && data.rates && data.rates[activeCurrency] !== undefined) {
      // Return the converted value for the active currency.
      return parseFloat(data.rates[activeCurrency]);
    } else {
      console.log(`Conversion rate for ${activeCurrency} not found.`);
      return 1;
      //throw new Error(`Conversion rate for ${activeCurrency} not found.`);
    }
  } catch (error) {
    console.error("Error converting currency:", error);
    // Optionally, you could return the original price as a fallback.
    return 1;
  }
}

function getCookie(name) {
  const cookieArr = document.cookie.split(";");
  for (let i = 0; i < cookieArr.length; i++) {
    const cookie = cookieArr[i].trim();
    // Check if this cookie string begins with the name we want.
    if (cookie.indexOf(name + "=") === 0) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}
